
import { Component, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/entities/page-request'
import CommonTable from '@/components/common-table/index.vue'
import TableAction from '@/entities/table-action'
import CardBody from '@/components/card-body/index.vue'
import SortDropdown from '@/components/sort-dropdown/index.vue'
import { ElTable } from 'element-ui/types/table'
import Transactionlog from '@/entities/transactionlog'
import tableSort from '@/mixins/table-sort'
import dictAction from '@/mixins/dict-action'
import workzone from '@/mixins/workzone'
import config from '@/config'
import util from '@/lib/util'
import ReturnCaseWh from '@/entities/returncasewh'

class PageListRequest extends PageRequest {
  workZoneCode: string
  doNo: string
  dateFrom: string
  dateTo: string
  vendor: string
  referenceNo: string
}

@Component({
  components: {
    CommonTable,
    CardBody,
    SortDropdown
  },
  mixins: [tableSort, dictAction, workzone]
})
export default class dsdreceMaster extends AbpBase
  implements TableAction<Transactionlog> {
  [x: string]: any
  pagerequest: PageListRequest = new PageListRequest()
  vendorList: Array<any> = []

  isExporting: boolean = false


  dictEpodDoMaster = 'epod_do_master'

  get tableLoading() {
    return this.$store.state.transactionlog.loading
  }

  get tableDataList() {
    return this.$store.state.transactionlog.list
  }

  get tablePagination() {
    return {
      pageNo: this.$store.state.transactionlog.currentPage,
      pageSize: this.$store.state.transactionlog.pageSize,
      total: this.$store.state.transactionlog.totalCount
    }
  }

  @Watch('hideWorkZoneFilter', { deep: true, immediate: true })
  onWorkZoneFilterHiddenChange(val) {
    this.$set(
      this.table,
      'height',
      val
        ? `calc(${config.commonTableHeight} - 20px)`
        : `calc(${config.commonTableHeight})`
    )
  }

  table = this.$standardTableData({
    hideHeader: false,
    title: this.L('Return Case Wh'),
    query: {
      //add search field : step 2 : set query for search variable
      WorkZoneCode: null,
      DoNo: null,
      DateTo: null,
      Status: null,

    },
    searchData: [
      {
        type: 'dateRange',
        title: 'Date Range',
        clearable: true,
        modelName: ['dateFrom', 'dateTo']
      },
      {
        type: 'select',
        model: 'workZoneCode',
        title: 'WorkZone',
        key: 'returnForm',
        clearable: true,
        filterable: true,
        option: [],
        hide: true
      },
      {
        type: 'input',
        title: 'doNo',
        model: 'doNo',
        clearable: true
      },

      {
        type: 'input',
        title: 'referenceno',
        model: 'referenceNo',
        clearable: true
      }
    ],
    columns: [
      {
        key: 'collapseColumn',
        hide: true,
        render: (h: any, ctx: any) => {
          return h(
            'span',
            this.getTableRef().$scopedSlots.collapseColumn(ctx.row)
          )
        }
      },
      {
        title: this.L('Date'),
        sortable: true,
        key: 'creationTime',
        render: (h: any, ctx: any) => {
          return h(
            'span',
            this.getTableRef().$scopedSlots.creationTime(ctx.row)
          )
        }
      },
      {
        title: this.L('TRANSACTION'),
        sortable: true,
        key: 'transaction'
      },
      {
        title: this.L('DOC NUMBER'),
        sortable: true,
        key: 'docNumber'
      },
      {
        title: this.L('RETURN FROM'),
        sortable: true,
        key: 'returnFrom'
      },
      {
        title: this.L('RETURN TO'),
        sortable: true,
        key: 'returnTo'
      },
      {
        title: this.L('TRACE ID'),
        sortable: true,
        key: 'traceId'
      },
      {
        title: this.L('SEAL NO 1.'),
        sortable: true,
        key: 'sealId1'
      },
      {
        title: this.L('SEAL NO 2.'),
        sortable: true,
        key: 'sealId2'
      },

      {
        title: this.L('Part No'),
        sortable: true,
        key: 'partNo'
      },
      {
        title: this.L('EMPLOYEE ID'),
        sortable: true,
        key: 'employeeId'
      }
    ]
  })

  async doTableSearch() {
    this.pagerequest.maxResultCount = this.tablePagination.pageSize
    this.pagerequest.skipCount =
      (this.tablePagination.pageNo - 1) * this.tablePagination.pageSize
    this.pagerequest.dateFrom = this.table.query.dateFrom
    this.pagerequest.dateTo = this.table.query.dateTo
    this.pagerequest.workZoneCode =
      this.workZone === 'ALL' ? this.table.query.workZoneCode : this.workZone
    this.pagerequest.vendor = this.vendorList !== null ? this.table.query.vendorList : null;
    this.pagerequest.doNo = this.table.query.doNo
    this.pagerequest.referenceNo = this.table.query.referenceNo
    await this.$store.dispatch({
      type: 'transactionlog/getAll',
      data: this.pagerequest
    })
  }

  doTablePageSizeChange(pageSize: number) {
    this.$store.commit('transactionlog/setPageSize', pageSize)
    this.doTableSearch()
  }

  doTablePageChange(pageNo: number) {
    this.$store.commit('transactionlog/setCurrentPage', pageNo)
    this.doTableSearch()
  }
  doTableRowClick(rowData: ReturnCaseWh) {
  }
  handleTableSort(itemKey, sortBy) {

    if (sortBy === 'none') {
      this.pagerequest.sorting = null
    } else {
      this.pagerequest.sorting = `${itemKey} ${sortBy}`
    }
    this.doTablePageChange(1)
  }

  getTableRef(): ElTable {
    return this.$refs.commonTable as ElTable
  }

  // 可操作动作
  tableActionList = [
    {
      icon: 'el-icon-download',
      key: 'export',
      name: 'Export'
    }
  ]

  async doTableAction() {

    if(this.isExporting){

      this.$notify.info({
        title: 'Exporting is ongoing',
        message: 'Please wait for a minute...'
      })

      return;
    }

    this.isExporting = true;

    try {
      let fileInfo = await this.$store.dispatch({
        type: 'transactionlog/doreceiptExport',
        data: {
          workZoneCode: this.pagerequest.workZoneCode,
          dateFrom: this.pagerequest.dateFrom,
          dateTo: this.pagerequest.dateTo,
          vendorCode: this.pagerequest.vendor,
          sorting: this.pagerequest.sorting,
          filter: null,
          fileType: 'xlsx'
        }
      })
      if (!fileInfo) {
        return
      }
      let res = await this.$store.dispatch({
        type: 'app/downloadTempFile',
        data: fileInfo
      })
      util.downloadRawDataToFile(fileInfo.fileName, res.data)
      this.$notify.success({
        title: 'Success',
        message: 'Export Success'
      })
      this.isExporting = false
    } catch (e) {
      console.log(e)
      this.$notify.error({
        title: 'Failed',
        message: 'Export Failed'
      })
      this.isExporting = false
    }
  }

  async doRefreshTable(){
    this.doTableSearch()
  }

  async created() {
    this.initTableColumnSort(this.table.columns)
    this.vendorSearchData()
    await this.handleWorkZoneSearchData(this.table)
    this.doTableSearch()
  }
  async vendorSearchData() {
    let res = await this.$store.dispatch({
      type: 'transactionlog/getVendorListing',
      data: {
        workZoneCode: this.workZone === 'ALL' ? this.table.query.workZoneCode : this.workZone
      }
    })

    this.vendorList = (res || []).map(t => ({
      label: `${t.vendor} - ${t.vendorName}`,
      value: t.vendor
    }));

    const vendorSearchDataIndex = this.table.searchData.findIndex(item => item.model === 'vendorList');
    if (vendorSearchDataIndex !== -1) {
      this.$set(this.table.searchData[vendorSearchDataIndex], 'option', this.vendorList);
    }
  }
}
